import { StyleSheet } from 'react-native';

import { type ParagraphTextProps, Text, tokens } from '@fhs/ui';

export const NutritionDisclaimerText = (props: ParagraphTextProps) => {
  const { size = 'sm', style, ...rest } = props;
  return <Text.Paragraph size={size} {...rest} style={[styles.paragraphStyles, style]} />;
};

const styles = StyleSheet.create({
  paragraphStyles: {
    marginTop: 16,
    color: tokens.colors.$houseDark,
    lineHeight: 16.8,
  },
});
